import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet, apiPost } from "../../api/apiclient";
import { TASK_STATUS } from "../../api/endpoints";

// Async thunk for creating AI agents
export const statusAiAgent = createAsyncThunk(
  "statusAiAgent",
  async (params, { rejectWithValue }) => {
    console.log('params',params)
    try {
       const response = await apiGet(`${TASK_STATUS}${params}/`);
      // mock the response
     // const response  = await mockApiCall();
    
     
      if (response?.data.status === "success") {
        return response.data;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);





const NewAgenSelectorSlice = createSlice({
  name: "ai_agent",
  initialState: {
    statusAgentLoading: false,
    statusAgentError: null,
    statusAgent: null,
    taskId:null
  },
  reducers: {
    resetStatusAgent:(state,payload)=>{
      state.statusAgentLoading= false
      state.statusAgentError= null
      state.statusAgent= null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(statusAiAgent.pending, (state) => {
        state.statusAgentLoading = true;
        state.statusAgentError = null;
      })
      .addCase(statusAiAgent.fulfilled, (state, action) => {
        state.statusAgentLoading = false;
        state.statusAgent =  action.payload
      })
      .addCase(statusAiAgent.rejected, (state, action) => {
        state.statusAgentLoading = false;
        state.statusAgentError = action.payload;
      });
  },
});

// Exporting the action to save form details
export const { resetStatusAgent,saveTaskId } = NewAgenSelectorSlice.actions;

// Exporting the reducer
export default NewAgenSelectorSlice.reducer;
